import React, { useContext } from 'react';
import { Observer } from 'mobx-react';
import { Form, Switch } from 'antd';
import InputEmail from '../../../shared/components/Inputs/InputEmail';
import InputPasswordSimple from '../../../shared/components/Inputs/InputPasswordSimple';
import { ContextSessionStores } from '../../Context/Context';
import { t } from '../../../shared/i18n/util';
import { authLayout as formItemLayout } from '../../../shared/utils/constants';
import { AuthForm, ButtonAuth, RememberMeSection, RememberMeText } from '../../styles';
import { BoxFlexAllCentered } from '../../../Main/common/styles';

export const SessionAuthForm = () => {
  const { store } = useContext(ContextSessionStores);
  const [form] = Form.useForm();
  const FormItem = Form.Item;

  return (
    <Observer>
      {() => (
        <AuthForm onFinish={store.onFinish} layout="vertical" id={'session-auth-form'} autoComplete={'off'}>
          <InputEmail
            placeholder={t('labelEnterEmail')}
            {...{ form }}
            required={true}
            propertyName={'email'}
            {...{ formItemLayout }}
            validateLength={50}
            requiredMsg={t('msgFieldRequired')}
            validatedMsg={t('msgValidEmail')}
          />
          <InputPasswordSimple
            icon={false}
            colon={true}
            required={true}
            {...{ form }}
            propertyName={'password'}
            placeholder={t('labelPassword')}
            requiredMsg={t('msgFieldRequired')}
            withShowHideIcon={true}
          />
          <RememberMeSection>
            <FormItem name="remember" valuePropName="checked">
              <RememberMeText>{t('labelRememberPassword')}</RememberMeText>{' '}
              <Switch defaultChecked size="small" className="remember-me" />
            </FormItem>
          </RememberMeSection>
          <BoxFlexAllCentered>
            <ButtonAuth type="primary" htmlType="submit">
              {t('labelLogIn')}
            </ButtonAuth>
          </BoxFlexAllCentered>
        </AuthForm>
      )}
    </Observer>
  );
};

export default SessionAuthForm;
